<div *transloco="let t" class="relative">
	<button class="absolute right-2 top-2 z-10" mat-icon-button (click)="dialogRef.close(false)" [attr.aria-label]="t('commonActions.close')">
		<mat-icon>close</mat-icon>
	</button>
	<h2 mat-dialog-title cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane">{{ t('common.attention') }}</h2>
	<mat-dialog-content mat-dialog-content style="white-space: pre-wrap">
		<p>
			{{ t('permissions.permissionTypeWrong') }}
		</p>
		<p>
			{{ t('permissions.goToAraAppDescription') }}
		</p>
	</mat-dialog-content>
	<mat-dialog-actions class="flex flex-row items-center justify-end" mat-dialog-actions>
		<a href="{{ araAppUrl }}" class="confirm-button m-2" color="primary" mat-raised-button>
			<mat-icon>check</mat-icon>
			{{ t('permissions.goToAraApp') }}
		</a>
	</mat-dialog-actions>
</div>
